import React, { ReactElement, ReactNode } from "react";
import { useStyles } from "./MainLayout.styles";
import { Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useWebViewContext } from "../../components/WebViewProvider/webViewContext";
import Header from "../Header";

// import  logo from "assets/logo.svg"

interface MainLayoutProps {
    children: ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps): ReactElement => {
    const styles = useStyles();
    const { isWebView } = useWebViewContext();
    const theme = useTheme();
    const mdUp = useMediaQuery(theme.breakpoints.up("md"));

    return (
        <div className={styles.mainContainer}>
            {!isWebView && <Header />}

            <Container maxWidth="sm" sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                <div className={mdUp ? styles.contentMd : styles.content}>{children}</div>
            </Container>

            {!isWebView && (
                <Container>
                    <Box
                        sx={{
                            display: "flex",
                            gap: "16px",
                            flexDirection: { xs: "column", md: "row" },
                            maxWidth: "1114px",
                            margin: "0 auto",
                            marginTop: "100px",
                            marginBottom: "32px",
                            width: "100%",
                        }}
                    >
                        <div className={styles.panelDark}>
                            <Box className="icon">
                                <svg width="69" height="69" viewBox="0 0 69 69" fill="none">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M62.5 34.5C62.5 49.964 49.964 62.5 34.5 62.5C19.036 62.5 6.5 49.964 6.5 34.5C6.5 19.036 19.036 6.5 34.5 6.5C49.964 6.5 62.5 19.036 62.5 34.5Z"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></path>
                                    <path
                                        d="M68.5 34.5C68.5 15.722 53.277 0.5 34.5 0.5C15.722 0.5 0.5 15.722 0.5 34.5C0.5 53.277 15.722 68.5 34.5 68.5C48.521 68.5 60.556 60.012 65.756 47.896"
                                        stroke="white"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></path>
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M51.9624 23.3638C51.9214 22.9908 51.4674 22.8308 51.2014 23.0958L47.3554 25.9638C46.7284 26.3608 45.7914 26.5448 44.9184 25.9638L43.0394 24.1568C42.3664 23.4838 42.3664 22.3928 43.0394 21.7198L45.8904 17.8018C46.1554 17.5358 45.9944 17.0808 45.6204 17.0408C43.5034 16.8148 41.3064 17.5218 39.7184 19.1508C38.1514 20.7558 37.4914 22.9138 37.7344 24.9868C37.9074 26.4528 37.3244 27.9058 36.2094 28.8718L19.2694 43.5498C17.5704 45.2478 17.5704 48.0278 19.2694 49.7268C20.9674 51.4248 23.7464 51.4248 25.4454 49.7268L40.0524 32.7748C41.0154 31.6568 42.4714 31.0648 43.9364 31.2518C46.0584 31.5228 48.2794 30.8428 49.9094 29.2128C51.5084 27.6138 52.1914 25.4488 51.9624 23.3638Z"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></path>
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M23.3361 47.427C22.8481 47.915 22.0561 47.915 21.5681 47.427C21.0801 46.939 21.0801 46.147 21.5681 45.659C22.0561 45.171 22.8481 45.171 23.3361 45.659C23.8241 46.147 23.8241 46.939 23.3361 47.427Z"
                                        stroke="white"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></path>
                                </svg>
                            </Box>
                            <Box className={styles.contentFooter}>
                                <Typography className={styles.smallHeading}>Kontaktní linka ČEZ Distribuce</Typography>
                                <Typography className={styles.phone}>800 850 860</Typography>

                                <Typography className={styles.subTitle}>PRO PORUCHY</Typography>
                                <Typography className={styles.description}>Nonstop</Typography>

                                <Typography className={styles.subTitle}>TECHNICKÉ POŽADAVKY</Typography>
                                <Typography className={`${styles.description} ${styles.lastItem}`}>
                                    V pracovní dny od 8 do 18 hodin
                                </Typography>
                            </Box>
                        </div>

                        <div className={styles.panelDark}>
                            <div className="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="69" height="69" viewBox="0 0 69 69" fill="none">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M27.2535 21.6514C28.3145 22.6294 28.7875 23.1894 29.7195 24.1854C30.7965 25.2874 30.7865 27.0464 29.6215 28.0914L27.6435 29.8814C25.2025 32.1134 36.4375 43.5614 39.0065 41.3104L40.9855 39.5204C42.1495 38.4754 43.9885 38.4634 45.0665 39.5634C45.9975 40.5614 46.6005 41.1024 47.5315 42.0984C48.6095 43.2004 48.9255 45.4144 47.7615 46.4604C37.8705 55.4084 12.7305 30.3844 22.8615 21.2754C24.0275 20.2304 26.1765 20.5494 27.2535 21.6514Z"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></path>
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M62.5 34.5C62.5 49.964 49.964 62.5 34.5 62.5C19.036 62.5 6.5 49.964 6.5 34.5C6.5 19.036 19.036 6.5 34.5 6.5C49.964 6.5 62.5 19.036 62.5 34.5Z"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></path>
                                    <path
                                        d="M68.5 34.5C68.5 15.722 53.277 0.5 34.5 0.5C15.722 0.5 0.5 15.722 0.5 34.5C0.5 53.277 15.722 68.5 34.5 68.5C48.521 68.5 60.556 60.012 65.756 47.896"
                                        stroke="white"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></path>
                                </svg>
                            </div>
                            <Box className={styles.contentFooter}>
                                <Typography className={styles.subTitle}>KOMUNIKUJTE ONLINE</Typography>
                                <Typography className={`${styles.description} ${styles.lastItem}`}>Distribuční portál</Typography>
                                <Typography className={styles.description}>Mobilní aplikace Proud</Typography>

                                <Typography className={styles.subTitle}>NAVŠTIVTE NÁS</Typography>
                                <Typography className={`${styles.description} ${styles.lastItem}`}>
                                    Mapa technických konzultačních míst
                                </Typography>
                            </Box>
                        </div>
                    </Box>
                </Container>
            )}
        </div>
    );
};
export default MainLayout;
